import { AppAlert } from '@models';
import { createAction, props } from '@ngrx/store';

export const showAlert = createAction(
  '[Alert] Show',
  props<{ alert: AppAlert }>()
);
export const clearAlert = createAction(
  '[Alert] Clear',
  props<{ name: string }>()
);
